/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Cancel from './Cancel/index'
import React from 'react'
import Save from './Save/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/CompleteTreatment/Content/Actions"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 style={{'--bblr-1-AjnkD': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-2-AjnkD': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-3-AjnkD': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pt-4-AjnkD': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-5-AjnkD': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-6-AjnkD': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-7-AjnkD': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bc-8-AjnkD': dtColorsWhite,'--bc-9-AjnkD': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Cancel
  viewPath={`${viewPath}/Cancel`}
/>
<Save
  viewPath={`${viewPath}/Save`}
/>
</div>
{children}
</React.Fragment>)
}